import React, { createContext, useContext, useState } from "react";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
	const [auth, setAuth] = useState({
		isLoggedIn: localStorage.getItem("isLoggedIn") === "true",
		role: localStorage.getItem("role"),
	});

	const login = (user, role) => {
		localStorage.setItem("isLoggedIn", "true");
		localStorage.setItem("role", role);
		setAuth({ isLoggedIn: true, user, role });
	};

	const logout = () => {
		localStorage.removeItem("isLoggedIn");
		localStorage.removeItem("role");
		setAuth({ isLoggedIn: false, user: null, role: null });
	};

	return (
		<AuthContext.Provider value={{ ...auth, login, logout }}>
			{children}
		</AuthContext.Provider>
	);
};

export const useAuth = () => useContext(AuthContext);
